import Vue from "vue";
import Vuetify from 'vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import VueAxios from 'vue-axios';
import dotenv from 'dotenv'
import VueAnalytics from 'vue-analytics'
import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
//import es from './i18n/es.ts'
import ApiService from './common/api.service'

Vue.use(VueAxios, axios);

const vuetify_options = {
  theme: {
    themes: {
      light: {
        accent: colors.purple.darken2, // #E53935
        primary: colors.lightBlue.accent3, // #3F51B5
        secondary: colors.amber.accent3, // #3F51B5
      },
    },
  },
}

Vue.use(VueAnalytics, {
  id: 'UA-171510165-1'
})

Vue.config.productionTip = false;
ApiService.init();

Vue.use(Vuetify)


new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetify_options),
  render: h => h(App)
}).$mount("#app");




Vue.use(Vuetify)

